import type { ChangeEvent } from 'react';
import { FormErrorMessage, Radio, RadioGroup } from '@ksyos/design-system';
import { get } from 'lodash';
import type {
    QuestionnaireCustomControlData,
    QuestionnaireCustomControlKeys,
} from '../../../../../common/validation/customControls/somnology';
import type { ValidationErrors } from '../../../../utils/validation';
import { translateKey } from '../../../../translate';
import { RadioGroupWrapper } from '../../molecules/radioGroupWrapper/RadioGroupWrapper';
import { StyledCard } from '../../molecules/styledCard/StyledCard';

interface IQuestionnaireOption {
    label: string;
    value: number;
}

interface IQuestionnaireRadioGroupProps {
    customControlData: QuestionnaireCustomControlData;
    customControlKey: QuestionnaireCustomControlKeys;
    errors: ValidationErrors;
    handleChange: (update: { [customControlKey: string]: number }) => void;
    questionnaireOptions: IQuestionnaireOption[];
}

export function QuestionnaireRadioGroup(props: IQuestionnaireRadioGroupProps) {
    return (
        <>
            <StyledCard error={props.errors.has(props.customControlKey as string)}>
                <RadioGroupWrapper>
                    <RadioGroup
                        onChange={(event: ChangeEvent<HTMLInputElement>) => {
                            props.handleChange({ [props.customControlKey]: Number(event.target.value) });
                        }}
                        value={
                            get(props.customControlData, props.customControlKey) !== null
                                ? (props.customControlData as any)[props.customControlKey].toString()
                                : ''
                        }
                    >
                        {props.questionnaireOptions.map((option) => (
                            <Radio
                                id={props.customControlKey + option.value.toString()}
                                key={(props.customControlKey as string) + option.value}
                                label={option.label}
                                value={option.value.toString()}
                            />
                        ))}
                    </RadioGroup>
                </RadioGroupWrapper>
            </StyledCard>
            {props.errors.has(props.customControlKey as string) && (
                <FormErrorMessage>{translateKey('validation.any_selected')}</FormErrorMessage>
            )}
        </>
    );
}
